import { createApp, nextTick } from "vue";
import RebuiltApp from "./rebuilt/RebuiltApp.vue";
import "./rebuilt/rebuilt.css";

const app = createApp(RebuiltApp);
app.config.errorHandler = (error) => {
  console.error(error);
  if (!document.querySelector(".focus-main")) {
    window.dispatchEvent(new Event("947654:failed"));
  }
};
app.mount("#app");
void nextTick(() => {
  if (document.querySelector(".focus-main")) {
    window.dispatchEvent(new Event("947654:ready"));
  }
});
